import React, { useState } from 'react';
import StepOne from './EnrolmentStep1';
import EnrolmentStepOne from './EnrolmentStep1';
import { Grid } from '@mui/material';
// import StepOne from './components/StepOne';
// import StepTwo from './components/StepTwo';
// import StepThree from './components/StepThree';
// import StepFour from './components/StepFour';

const ClassDetailsAndPackage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});

  const totalSteps = 4;

  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <EnrolmentStepOne onNext={handleNext} />;
    //   case 2:
    //     return <StepTwo onBack={handleBack} onNext={handleNext} />;
    //   case 3:
    //     return <StepThree onBack={handleBack} onNext={handleNext} />;
    //   case 4:
    //     return <StepFour onBack={handleBack} formData={formData} />;
      default:
        return null;
    }
  };

  return (
    <Grid container>

      {/* Step indicator (text only) */}
      {/* <Grid item xs={12} textAlign="end">
        <strong>Step {currentStep} of {totalSteps}</strong>
     </Grid> */}

      {/* Render current step */}
      <Grid item xs={12}>
      {renderStep()}
      </Grid>
    </Grid>
  );
};

export default ClassDetailsAndPackage;
